export default __webpack_public_path__ + "static/media/resource-parking-featured-image-placeholder.87e1c400.svg";